import {useBundleByExamId, type CertificationBundle} from '@udemy/react-certification-preparation';

export interface BundleCoursesForVoucher {
    bundle: CertificationBundle | undefined;
    courseIdsToUpsell: number[];
    isLoading: boolean;
}

export function useBundleCoursesForVoucher(
    offerId: string | undefined,
    cartCourseIds?: Set<number>,
): BundleCoursesForVoucher {
    const {bundle, isLoading} = useBundleByExamId(offerId ?? null);

    const courseIdsToUpsell =
        bundle?.contents.map((c) => c.id).filter((id) => !cartCourseIds?.has(id)) ?? [];

    return {bundle, courseIdsToUpsell, isLoading};
}
